/**
 * Controller: ReportsCreateShowMessageModal
 */
angular.module('acme.view.application.reports.create.showMessageModal.controllers', [])
.controller('ReportsCreateShowMessageModalController', [ '$scope', '$sce', '$uibModalInstance', 'currentMessage', 'currentTitle', 'safe', function ($scope, $sce, $uibModalInstance, currentMessage, currentTitle, safe) {

    $scope.errors = [];

    $scope.model = [];

    $scope.init = function() {
      $scope.model = (safe) ? $sce.trustAsHtml(currentMessage) : currentMessage;
      $scope.title = currentTitle;
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close();
    };

    $scope.init();

  }]);